import update from 'immutability-helper';
import { ActionType, defaultAction } from '../types';
import { ACTION_TYPES } from '../types/businessBankingTypes';

export type BusinessBankingState = {
  showARSettings: boolean;
  showARCreateWarningModal: boolean;
  showReimbursementApproverRegistrationModal: boolean;
  showReimbursementCreateLinkModal: boolean;
  showReimbursementConfig: boolean;
  showAddVendorModal: boolean;
  showAddPayableInvoiceModal: boolean;
};

const initialState: BusinessBankingState = {
  showARSettings: false,
  showARCreateWarningModal: false,
  showReimbursementApproverRegistrationModal: false,
  showReimbursementCreateLinkModal: false,
  showReimbursementConfig: false,
  showAddVendorModal: false,
  showAddPayableInvoiceModal: false,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.SHOW_AR_SIDE_SETTINGS:
      return update(state, {
        showARSettings: {
          $set: payload,
        },
      });
    case ACTION_TYPES.SHOW_AR_CREATE_WARNING_MODAL:
      return update(state, {
        showARCreateWarningModal: {
          $set: payload,
        },
      });
    case ACTION_TYPES.SHOW_REIMBURSEMENT_APPROVER_REGISTRATION_MODAL:
      return update(state, {
        showReimbursementApproverRegistrationModal: {
          $set: payload,
        },
      });
    case ACTION_TYPES.SHOW_REIMBURSEMENT_CREATE_LINK_MODAL:
      return update(state, {
        showReimbursementCreateLinkModal: {
          $set: payload,
        },
      });
    case ACTION_TYPES.SHOW_REIMBURSEMENT_CONFIG:
      return update(state, {
        showReimbursementConfig: {
          $set: payload,
        },
      });
    case ACTION_TYPES.TOGGLE_ADD_VENDOR_MODAL:
      return update(state, {
        showAddVendorModal: {
          $set: !state.showAddVendorModal,
        },
      });
    case ACTION_TYPES.TOGGLE_ADD_PAYABLE_INVOICE_MODAL:
      return update(state, {
        showAddPayableInvoiceModal: {
          $set: !state.showAddPayableInvoiceModal,
        },
      });
    default:
      return state;
  }
};
